<template>
  <span v-if="publisher_title" class="campaign-publisher" title="Publisher">
    {{ publisher_title }}
  </span>
</template>

<script>
import "./campaign-publisher.scss"

export default {
  name: "campaign-publisher",
  props: {
    publishers: {
      required: true,
    },
    publisher_id: {
      required: true,
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {},
  computed: {
    publisher_title() {
      if (this.publisher_id === null) return
      const publisher = this.publishers.find((p) => p.id === this.publisher_id)
      if (publisher) return publisher.title
    },
  }
}
</script>
